<div class="no-tariff-info" data-test="tariff-assignment-info">
  <eop-icon [vaylensFont]="true" [identifier]="'info-circle-outlined'" [color]="IconColor.NORMAL">
  </eop-icon>
  <div>
    <p class="sub-heading-m info-text">{{ 'GLOBAL.NO_TARIFF_INFO' | translate }}</p>
    <button
      eopButton
      data-test="tariff-assignment-info-learn-more"
      (click)="openMoreInfo()"
      [color]="ButtonColor.OUTLINE_TRANSPARENT"
      [size]="ButtonSize.MEDIUM">
      {{ 'GLOBAL.LEARN_MORE' | translate }}
    </button>
  </div>
</div>
